export const PageZoomVal = (zoomValue, settingSize, viewport) => {
  let newSettings = {};
  let newZoomValue = zoomValue === 'fit' ? zoomValue : parseInt(zoomValue);
  if (newZoomValue === 'fit') {
    if (viewport.height) {
      const scaling = Number.parseFloat((viewport.height - 200) / settingSize.heightInPX).toFixed(
        2,
      );
      newSettings.scaling = scaling;
    }
  } else {
    newSettings.scaling = Number(newZoomValue) / 100;
  }
  newSettings.zoom = newZoomValue;
  return newSettings;
};
